/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { usageGetBillingEmail } from "../funcs/usageGetBillingEmail.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { BillingEmail } from "../models/components/billingemail.js";
import {
  GetBillingEmailRequest,
  GetBillingEmailSecurity,
} from "../models/operations/getbillingemail.js";
import { unwrapAsync } from "../types/fp.js";
export type GetBillingEmailQueryData = BillingEmail;

export function prefetchGetBillingEmail(
  queryClient: QueryClient,
  client$: GramCore,
  request?: GetBillingEmailRequest | undefined,
  security?: GetBillingEmailSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildGetBillingEmailQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildGetBillingEmailQuery(
  client$: GramCore,
  request?: GetBillingEmailRequest | undefined,
  security?: GetBillingEmailSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (context: QueryFunctionContext) => Promise<GetBillingEmailQueryData>;
} {
  return {
    queryKey: queryKeyGetBillingEmail({ gramSession: request?.gramSession }),
    queryFn: async function getBillingEmailQueryFn(
      ctx,
    ): Promise<GetBillingEmailQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(usageGetBillingEmail(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyGetBillingEmail(
  parameters: { gramSession?: string | undefined },
): QueryKey {
  return ["@gram/client", "usage", "getBillingEmail", parameters];
}
